// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox[data-v-13012cae]  .el-badge__content.is-fixed.is-dot {\n  right: 1px;\n  top: 5px;\n}", ""]);
// Exports
module.exports = exports;
